export default __webpack_public_path__ + "static/media/aion-debit-card.bd64df17.png";